import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

// Import translation files
import esAR from '../locales/es-AR.json';

const resources = {
  'es-AR': {
    translation: esAR,
  },
};

const getInitialLanguage = (): string => {
  // Always use Spanish Argentina
  return 'es-AR';
};

i18n.use(initReactI18next).init({
  resources,
  lng: getInitialLanguage(),
  fallbackLng: 'es-AR',
  debug: process.env.NODE_ENV === 'development',

  interpolation: {
    escapeValue: false, // React already escapes by default
  },

  // Additional options
  react: {
    useSuspense: false, // Set to false to avoid suspense in SSR
  },
});

export default i18n;
